function findIndex(arr, predicate, fromIndex) {
    if (fromIndex === void 0) { fromIndex = 0; }
    for (var i = fromIndex; i < arr.length; i++) {
        if (predicate(arr[i], i)) {
            // æ¾å°ç»æ­¢å¾ªç¯
            return i;
        }
    }
    return -1;
}
export default findIndex;
//# sourceMappingURL=find-index.js.map